module.exports = __webpack_public_path__ + "static/media/ks_testtube4.368a8a9f.svg";